import { useEffect, useState } from "react";
import { Outlet, useParams } from "react-router-dom";
import { apiGet, type Patient } from "../api/client";
import { EmptyMessage } from "../components/EmptyMessage";
import { PatientHeader } from "../components/PatientHeader";

export function PatientLayout() {
  const { id } = useParams();
  const [patient, setPatient] = useState<Patient | null>(null);

  useEffect(() => {
    if (!id) return;
    let cancelled = false;
    apiGet<Patient>(`/patients/${id}`).then((data) => {
      if (!cancelled) setPatient(data);
    });
    return () => {
      cancelled = true;
    };
  }, [id]);

  if (!patient) {
    return (
      <EmptyMessage>
        <p>Loading patient…</p>
      </EmptyMessage>
    );
  }

  return (
    <>
      <PatientHeader patient={patient} />
      <section className="ne__patient__view">
        <Outlet context={{ patient }} />
      </section>
    </>
  );
}
